export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/var/www/vhosts/leisureking.vitrion.nl/httpdocs/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/:path(.*)',
    name: '/[...path]',
    component: () => import('/var/www/vhosts/leisureking.vitrion.nl/httpdocs/src/pages/[...path].vue'),
    /* no children */
  },
  {
    path: '/app_subscriptions',
    /* internal name: '/app_subscriptions' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/app_subscriptions/[id]',
        component: () => import('/var/www/vhosts/leisureking.vitrion.nl/httpdocs/src/pages/app_subscriptions/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/auth',
    name: '/auth',
    component: () => import('/var/www/vhosts/leisureking.vitrion.nl/httpdocs/src/pages/auth.vue'),
    /* no children */
  },
  {
    path: '/oauth',
    /* internal name: '/oauth' */
    /* no component */
    children: [
      {
        path: 'callback',
        /* internal name: '/oauth/callback' */
        /* no component */
        children: [
          {
            path: ':type',
            name: '/oauth/callback/[type]',
            component: () => import('/var/www/vhosts/leisureking.vitrion.nl/httpdocs/src/pages/oauth/callback/[type].vue'),
            /* no children */
          }
        ],
      }
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

